import { ORDER_PARTS } from './variables';

type OPHI = { [key in typeof ORDER_PARTS[number] | 'preview' ]: { showHelpBtn: boolean } };

export const orderPartsHeaderInfos: OPHI = {
    shaft: {
        showHelpBtn: true,
    },
    feather: {
        showHelpBtn: true,
    },
    thread: {
        showHelpBtn: true,
    },
    kebiki: {
        showHelpBtn: true,
    },
    nock: {
        showHelpBtn: true,
    },
    arrowhead: {
        showHelpBtn: true,
    },
    arrowlength: {
        showHelpBtn: true,
    },
    unit: {
        showHelpBtn: true,
    },
    arrowinsert: {
        showHelpBtn: true,
    },
    twine: {
        showHelpBtn: true,
    },
    lame: {
        showHelpBtn: false,
    },
    carving: {
        showHelpBtn: true,
    },
    familycrest: {
        showHelpBtn: true,
    },
    featherinside: {
        showHelpBtn: true,
    },
    decoration: {
        showHelpBtn: true,
    },
    typezero: {
        showHelpBtn: false,
    },
    preview: {
        showHelpBtn: false,
    },
};
